"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadElements = void 0;

var _constants = require("./constants");

var _script = require("./script");

let elementsPromise;

const loadElements = elementsClientUrl => {
  if (!elementsPromise) {
    elementsPromise = new Promise((resolve, reject) => {
      if (typeof window !== 'object') {
        reject(new Error(_constants.ELEMENTS_NOM_DOM_ERROR_MESSAGE));
        return;
      }

      if (window.BasisTheoryElements) {
        resolve(window.BasisTheoryElements);
        return;
      }

      try {
        let url = `https://${"js.basistheory.com"}/elements`;

        if (typeof elementsClientUrl !== 'undefined') {
          try {
            const urlObject = new URL(elementsClientUrl);
            url = urlObject.toString().replace(/\/$/u, '');
          } catch {
            throw new Error('Invalid format for the given Elements client url.');
          }
        }

        let script = (0, _script.findScript)(url);

        if (!script) {
          script = (0, _script.injectScript)(url);
        }

        script.addEventListener('load', () => {
          if (window.BasisTheoryElements) {
            resolve(window.BasisTheoryElements);
          } else {
            reject(new Error(_constants.ELEMENTS_SCRIPT_LOAD_ERROR_MESSAGE));
          }
        });
        script.addEventListener('error', event => {
          reject((event === null || event === void 0 ? void 0 : event.error) || new Error(_constants.ELEMENTS_SCRIPT_UNKNOWN_ERROR_MESSAGE));
        });
      } catch (error) {
        reject(error);
        return;
      }
    });
  }

  return elementsPromise;
};

exports.loadElements = loadElements;